// extracted by mini-css-extract-plugin
export var card = "_ux-0";
export var details = "_ux-1";